export default {
    // 通过票号或证件号获取航班信息
    async getFlightWhitoutCheck(params) {
        let actiontype = 'getFlightWhitoutCheck'
        return await this.fetch(actiontype, params)
    },
    // 校验是否可以升舱
    async checkCanNewUpCabinHandler(params) {
        let actiontype = 'OrderService_checkCanUpCabinHandler'
        return await this.fetch(actiontype, params)
    },
    // 补发票
    async reissueNewInvoiceHandler(params) {
        let actiontype = 'OrderService_reissueInvoiceHandler'
        return await this.fetch(actiontype, params)
    },
    // 升舱下单
    async createNewTicketUpCabin(params) {
        let actiontype = 'OrderService_TicketUpCabinHandler'
        return await this.fetch(actiontype, params)
    },
    // 升舱订单详情  newUpgradeDetail
    async newUpgradeDetail(params) {
        let actiontype = 'newUpgradeDetail'
        return await this.fetch(actiontype, params)
    },
    // 升舱订单退单
    async newUpgradeRefund(params) {
        let actiontype = 'createNewUpgradeRefund'
        return await this.fetch(actiontype, params)
    },
    // 升舱订单列表
    async getMyUpCabinList(params) {
        let actiontype = 'OrderQuery_GetMyUpCabinList'
        return await this.fetch(actiontype, params)
    },
    // 通过扫码字符串获取票号
    async searchUpgradesTicketNoByBn(params) {
        let actiontype = 'passengerservice_searchTicketNoByBn'
        return await this.fetch(actiontype, params)
    },
    // 新升舱获取支付信息
    async getUpgradePayUrl(params) {
        let actiontype = 'OrderQuery_GetUpgradePayUrl'
        return await this.fetch(actiontype, params)
    },
}


// WEBPACK FOOTER //
// ./src/interfaces/modules/upgrades.js